import React, { useEffect, useState } from "react";
import apiClient from "../Pages/Login/apiClient";

function AdminNotices({ scope = "mine", title = "運営からの連絡" }) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [notices, setNotices] = useState([]);

  useEffect(() => {
    const fetchNotices = async () => {
      try {
        const query = scope === "global" ? "?scope=global" : "";
        const response = await apiClient.get(`${API_BASE_URL}/api/mypage/admin-notices/${query}`);
        setNotices(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Failed to fetch admin notices:", error);
      }
    };

    fetchNotices();
  }, [API_BASE_URL, scope]);

  if (notices.length === 0) {
    return null;
  }

  return (
    <section style={styles.wrap}>
      <div style={styles.header}>
        <span style={styles.kicker}>NOTICE</span>
        <h2 style={styles.title}>{title}</h2>
      </div>
      <div style={styles.list}>
        {notices.map((notice) => (
          <article key={notice.id} style={styles.card}>
            <div style={styles.cardTop}>
              <span style={{
                ...styles.badge,
                ...(notice.audience === "user" ? styles.personalBadge : styles.globalBadge),
              }}>
                {notice.audience === "user" ? "あなた宛" : "全体向け"}
              </span>
              <span style={styles.date}>{formatDate(notice.created_at)}</span>
            </div>
            <h3 style={styles.cardTitle}>{notice.title}</h3>
            <p style={styles.message}>{notice.message}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

function formatDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("ja-JP", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

const styles = {
  wrap: {
    width: "100%",
    maxWidth: 920,
    margin: "18px auto",
    padding: "0 16px",
    boxSizing: "border-box",
  },
  header: {
    display: "flex",
    alignItems: "baseline",
    gap: 10,
    marginBottom: 10,
  },
  kicker: {
    color: "#a86f00",
    fontSize: "0.72rem",
    fontWeight: 900,
    letterSpacing: "0.12em",
  },
  title: {
    margin: 0,
    color: "#211508",
    fontSize: "1.1rem",
    fontWeight: 900,
  },
  list: {
    display: "grid",
    gap: 10,
  },
  card: {
    background: "linear-gradient(135deg, #fffdf8 0%, #fff5df 100%)",
    border: "1px solid #e7c985",
    borderRadius: 16,
    padding: "14px 15px",
    boxShadow: "0 10px 24px rgba(64, 39, 8, 0.10)",
  },
  cardTop: {
    display: "flex",
    justifyContent: "space-between",
    gap: 10,
    alignItems: "center",
    marginBottom: 7,
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    borderRadius: 999,
    padding: "4px 9px",
    fontSize: "0.72rem",
    fontWeight: 900,
  },
  globalBadge: {
    background: "#211508",
    color: "#ffffff",
  },
  personalBadge: {
    background: "#ffe3a3",
    color: "#5d3500",
  },
  date: {
    color: "#7f6a4a",
    fontSize: "0.78rem",
    fontWeight: 700,
  },
  cardTitle: {
    margin: "0 0 6px",
    color: "#211508",
    fontSize: "1rem",
    fontWeight: 900,
  },
  message: {
    margin: 0,
    color: "#4b3520",
    lineHeight: 1.75,
    whiteSpace: "pre-wrap",
    fontSize: "0.94rem",
    fontWeight: 600,
  },
};

export default AdminNotices;
